import { createStore } from 'vuex'
import layout from './modules/layout'
import menu from './modules/menu'
import auth from './modules/auth'
import chat from './modules/chat'
import products from './modules/products'
import jobs from './modules/jobs'
import courses from './modules/courses'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    layout,
        chat,
        menu,
        auth,
        products,
        jobs,
        courses
  }
})
